import { useEffect, useState } from 'react';
import { useLang } from '../../context/LangContext';
import './HeroSection.css';

export default function HeroSection() {
  const { t } = useLang();
  const roles = t.hero.roles;

  const [roleIndex, setRoleIndex] = useState(0);
  const [displayed, setDisplayed] = useState('');
  const [phase, setPhase] = useState('typing');

  useEffect(() => {
    setRoleIndex(0);
    setDisplayed('');
    setPhase('typing');
  }, [roles]);

  useEffect(() => {
    const target = roles[roleIndex];
    if (phase === 'typing') {
      if (displayed.length < target.length) {
        const timer = setTimeout(() => setDisplayed(target.slice(0, displayed.length + 1)), 60);
        return () => clearTimeout(timer);
      } else {
        const timer = setTimeout(() => setPhase('waiting'), 1600);
        return () => clearTimeout(timer);
      }
    }
    if (phase === 'waiting') {
      const timer = setTimeout(() => setPhase('deleting'), 400);
      return () => clearTimeout(timer);
    }
    if (phase === 'deleting') {
      if (displayed.length > 0) {
        const timer = setTimeout(() => setDisplayed(displayed.slice(0, -1)), 32);
        return () => clearTimeout(timer);
      } else {
        setRoleIndex(i => (i + 1) % roles.length);
        setPhase('typing');
      }
    }
  }, [displayed, phase, roleIndex, roles]);

  return (
    <section className="hero-bg">
      <div className="hero-content">
        <div className="hero-band">
          <div className="hero-titles">
            <p className="hero-greeting">{t.hero.greeting}</p>
            <h1 className="hero-name">ALAN SOUZA</h1>
            <p className="hero-typewriter">
              <span className="hero-typewriter-text">{displayed}</span>
              <span className="hero-cursor">|</span>
            </p>
          </div>
        </div>
        <a href="#about">
          <div className="scroll-indicator">
            <svg width="42" height="64" viewBox="0 0 42 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="40" height="62" rx="20" stroke="#fff" strokeWidth="2" fill="none"/>
              <circle cx="21" cy="20" r="3" fill="#A8A095">
                <animate attributeName="cy" values="20;36;20" dur="1.7s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="1;0;1" dur="1.7s" repeatCount="indefinite" />
              </circle>
            </svg>
          </div>
        </a>
      </div>
    </section>
  );
}